class MyRequestTableFilterMap {
  constructor() {
    // @ts-ignore
    this.map = new Map();
    /* this.map.set(dataIndex, dbName); */
    // @ts-ignore
    this.map.set("taskGroupName", "TaskGroupID");
    // @ts-ignore
    this.map.set("categoryName", "CategoryName");
    // @ts-ignore
    this.map.set("taskLabelName", "TaskLabelName");
    // @ts-ignore
    this.map.set("highlyRegulated", "HighlyRegulated");
    // @ts-ignore
    this.map.set("triggerProcessName", "TriggerProcess");
    // @ts-ignore
    this.map.set("currentProcessor", "CurrentProcessor");
    // @ts-ignore
    this.map.set("processInitiatorName", "ProcessInitiator");
    // @ts-ignore
    this.map.set("primaryProcedureOwnerName", "PrimaryProcedureOwnerID");
    // @ts-ignore
    this.map.set("procedureOwnerName", "ProcedureOwnerID");
  }

  set(key: any, value: any) {
    // @ts-ignore
    this.map.set(key, value);
  }

  get(key: any) {
    // @ts-ignore
    return this.map.get(key);
  }
}

const myRequestListTableFilterMap = new MyRequestTableFilterMap();

export default myRequestListTableFilterMap;
